export const locale = {
    lang: 'es',
    data: {
        CHECKLIST: {
            EDIT: {
                TITLE: 'MODIFICAR CHECKLIST'
            }
        }
    }
};
